import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import arrowChevronRight from '@ibk/shared-assets/icons/arrow-chevron-right.svg';
import { TranslationProvider } from '@ibk/shared-translation';
import { sharedUiTranslations } from '../../translations';
import styles from './ProfileMenuItem.module.css';
export const ProfileMenuItemBase = ({ title, onClick, isVisible = true, info }) => {
    if (!isVisible) {
        return null;
    }
    const titleKey = title.toLowerCase().replaceAll(/\s+/g, '-');
    return (_jsxs("button", { className: styles.item, onClick: onClick, "data-testid": `profile-item-${titleKey}-button`, type: 'button', "aria-label": title, children: [_jsxs("h2", { className: styles.title, "data-testid": `profile-item-${titleKey}-title`, children: [title, info && _jsx("span", { className: styles.info, children: info })] }), _jsx("img", { src: arrowChevronRight, alt: '' })] }));
};
export const ProfileMenuItem = props => {
    return (_jsx(TranslationProvider, { translations: sharedUiTranslations, defaultLanguage: 'pt-BR', children: _jsx(ProfileMenuItemBase, { ...props }) }));
};
export default ProfileMenuItem;
